import { Module } from '../Module';
import { PKCEService } from '../services/PKCEService';
import { WindowLocationService } from '../services/WindowLocationService';

export interface IPKCELoginCtrlStateParams extends ng.ui.IStateParamsService {
  authorizationCode?: string;
  host?: string;
}

export class PKCELoginCtrl {

  private static LOGIN_URL = '/vizportal/api/clientxml/auth/pkce';

  public static $inject = [
    '$q',
    '$document',
    '$stateParams',
    'PKCEService',
    'WindowLocationService',
  ];

  constructor(
    $q: ng.IQService,
    $document: ng.IDocumentService,
    $stateParams: IPKCELoginCtrlStateParams,
    PKCEService: PKCEService,
    WindowLocationService: WindowLocationService
  ) {

    // This looks weird for a reason. This code would be expected to run inside a WebView component
    // embedded into Tableau Mobile. The WebView would be displaying a document loaded from, say
    // the online.tableau.com domain. But the server that issued the authorizationCode could be a
    // different domain, say, us-east-1.online.tableau.com. We need to POST the code to the right
    // server, so we have to get creative.
    function post(host: string, path: string, params: _.Dictionary<string>) {
      let url;
      if (host) {
        url = WindowLocationService.getProtocol() + '//' + host + path;
      } else {
        url = path;
      }
      const form = angular.element('<form>');
      form.attr('method', 'post');
      form.attr('action', url);
      for (const key in params) {
        const input = angular.element('<input>');
        input.attr('type', 'hidden');
        input.attr('name', key);
        input.attr('value', params[key]);
        form.append(input);
      }
      angular.element($document[0].body).append(form);
      form.submit();
    }

    PKCEService.getStoredCodeVerifier().then((codeVerifier: string) => {
      post($stateParams.host, PKCELoginCtrl.LOGIN_URL, {
        authorization_code: $stateParams.authorizationCode,
        code_verifier: codeVerifier,
      });
    });
  }
}

Module.instance().controller('PKCELoginCtrl', PKCELoginCtrl);
